import React from 'react'
import InfiniteScroll from "react-infinite-scroll-component";

import LocalizedStrings from 'react-localization';
import {LanguageContext} from "./LanguageContext"

var tracery = require('tracery-grammar');


const grammarEN = {
    "origin":["a #SUBJPROG# #VERBPROG# #SOFTWARE# #that#"],
    "that":["that", "which"],
    "SUBJPROG":["programmer", "software engineer", "hacker", "computer specialist", "engineer", "computer scientist", "scientist"],
    "VERBPROG":["wrote", "hacked together", "programmed", "drafted", "created", "made", "developed", "constructed", "put together", "invented"],
    "SOFTWARE":["#ADJSOFTWAREPHRASEa# program", "#ADJSOFTWAREPHRASEa# computer program", "#ADJSOFTWAREPHRASE# software", "#ADJSOFTWAREPHRASE# software system", "#ADJSOFTWAREPHRASEa# app", "#ADJSOFTWAREPHRASEa# application", "#ADJSOFTWAREPHRASEa# script", "some #ADJSOFTWAREPHRASE# code", "#ADJSOFTWAREPHRASEa# artificial intelligence", "#ADJSOFTWAREPHRASEa# neural network", "#ADJSOFTWAREPHRASEa# system", "#ADJSOFTWAREPHRASEa# bot"],
    "ADJSOFTWAREPHRASEa":["#ADJSOFTWARE.a#"],
    "ADJSOFTWAREPHRASE":["", "#ADJSOFTWARE#"],
    "ADJSOFTWARE":["quick", "complex", "marvelous", "new", "amazing", "intricate", "elaborate", "generative", "brilliant", "horrendous", "great", "innovative", "minimal", "specialized", "useful", "open source", "powerful", "optimized", "large", "interactive", "illegal", "hot", "intelligent", "experimental", "commercial", "bloated", "arcane", "agile", "autonomous", "basic", "complicated", "comprehensive", "dedicated", "distributed", "downloadable", "efficient", "excellent", "expensive", "flexible", "free", "functional", "generic", "inexpensive", "mobile", "modern", "popular", "professional", "proprietary", "quality", "reusable", "robust", "secure", "simple", "special", "specific", "standalone", "successful"],
    "PROGSENTENCE":["#VERBPROG# #SOFTWARE# #that#"],
}

const grammarDE = {
    "origin":["#SUBJPROG# #VERBPROG# #SOFTWARE# "],
    "SUBJPROG":["eine programmiererin", "ein programmierer", "ein hacker", "eine hackerin", "ein ingenieur", "eine ingenieurin", "eine informatikerin", "ein informatiker", "eine wissenschafterin", "ein wissenschafter"],
    "VERBPROG":["schrieb", "programmierte", "entwarf", "schuf", "erschuf", "entwickelte", "konstruierte", "bastelte", "erfand"],
    "SOFTWARE":["#SOFTWAREM#, der", "#SOFTWAREW#, die", "#SOFTWAREN#, das"],
    "SOFTWAREM":["etwas code", "einen #ADJM# bot"],
    "SOFTWAREW":["eine #ADJW# software", "eine #ADJW# app", "eine #ADJW# applikation", "eine #ADJW# künstliche intelligenz"],
    "SOFTWAREN":["ein #ADJN# programm", "ein #ADJN# computerprogramm", "ein #ADJN# softwaresystem", "ein #ADJN# skript", "ein #ADJN# neuronales netzwerk", "ein #ADJN# system"],
    "ADJ":["schnell", "komplex", "wunderbar", "neu", "elaboriert", "generativ", "brilliant", "furchtbar", "grossartig", "innovativ", "minimal", "spezialisiert", "brauchbar", "mächtig", "optimiert", "gross", "interaktiv", "illegal", "heiss", "intelligent", "experimentell", "kommerziell", "aufgeblasen", "agil", "autonom", "kompliziert", "verteilt", "herunterladbar", "effizient", "exzellent", "teuer", "elastisch", "frei", "funktional", "generisch", "billig", "mobil", "modern", "populär", "professionell", "proprietär", "qualitätsvoll", "wiederverwendbar", "robust", "simpl", "speziell", "spezifisch", "eigenständig", "erfolgreich"],
    "ADJM":["#ADJ#en"],
    "ADJW":["#ADJ#e"],
    "ADJN":["#ADJ#es"],
    "PROGSENTENCE":["#SOFTWAREM# #VERBPROG#, der", "#SOFTWAREW# #VERBPROG#, die", "#SOFTWAREN# #VERBPROG#, das",]
}

let strings = new LocalizedStrings({
    en:{
        title:"a programmer",
        description:"a recursive poem about the creation of programs."
    },
    de: {
        title:"eine programmiererin",
        description:"ein rekursives gedicht ähnlich dem bekannten kinderlied ”ein hund kam in die küche“."
    }
});

class AProgrammer extends React.Component {
    constructor(props) {
        super(props)

        this.state = {verses: []}
    }

    componentDidMount() {
        this.props.onchangePoemInfo(strings)
    }

    makeLine() {
        return this.grammar.expand("#PROGSENTENCE#").finishedText
    }

    addLine() {
        var verse = this.makeLine()
        this.setState({
            verses: this.state.verses.concat([verse])
        });
    }

    generate() {
        if (this.state.generatedLanguage !== this.context.language) {
            var grammarLang = strings.getLanguage() === "en" ? grammarEN : grammarDE;
            this.grammar = tracery.createGrammar(grammarLang);
            this.grammar.addModifiers(tracery.baseEngModifiers)

            var start = this.grammar.expand("#origin#").finishedText

            var lines = [start]
            for (var _= 0; _ < 100; _++) {
                lines.push(this.makeLine())
            }

            this.setState({
                verses: lines, generatedLanguage: this.context.language
            });
        }
    }

    fetchMoreData = () => {
        for(var i = 0; i < 20; i++) {
            this.addLine()
        }
    };

    render() {
        strings.setLanguage(this.context.language)
        this.generate()

        return <div className="poemDisplay">
            <InfiniteScroll
              dataLength={this.state.verses.length}
              next={this.fetchMoreData}
              hasMore={true}
              loader={<h4>Loading...</h4>}
            >
                {this.state.verses.map(function(verse, index) {
                    return <p key={index}>{verse}</p>;
                })}
            </InfiniteScroll>
        </div>
    }
}
AProgrammer.contextType = LanguageContext

export default AProgrammer
